var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9164_10301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5119 24.25H6.33288V11.398H10.5119V24.25ZM8.42012 9.64492C7.08411 9.64492 6 8.58789 6 7.31172C6 6.69861 6.25498 6.11062 6.70884 5.67709C7.1627 5.24356 7.77826 5 8.42012 5C9.06198 5 9.67754 5.24356 10.1314 5.67709C10.5853 6.11062 10.8402 6.69861 10.8402 7.31172C10.8402 8.58789 9.75613 9.64492 8.42012 9.64492ZM26.1482 24.25H21.9782V17.9937C21.9782 16.5027 21.9467 14.5906 19.8055 14.5906C17.6328 14.5906 17.2999 16.2105 17.2999 17.8863V24.25H13.1254V11.398H17.1335V13.1512H17.1919C17.7497 12.1414 19.1127 11.0758 21.146 11.0758C25.3745 11.0758 26.1527 13.7355 26.1527 17.1902V24.25H26.1482Z",
    fill: "#E84055"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9164_10301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.1527,
    height: 22,
    fill: "white",
    transform: "translate(6 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.773ace42dbb354b4217b01b9a8e5e1b2.svg";
export { ForwardRef as ReactComponent };